const fromArrayToString = (value)=>{
    if (!value && (value === null || value === void 0 ? void 0 : value.length) === 0) {
        return undefined;
    }
    const stringValue = Array.isArray(value) ? value[0] : value;
    return stringValue ? stringValue : undefined;
};

export { fromArrayToString };
//# sourceMappingURL=from-array-to-string.js.map
